import React, { FC } from 'react'

import JournalItem from '../JournalItem/JournalItem'
import css from './JournalFeed.module.scss'
import { journalItems_elements_edges_node } from '../../../__generated__/journalItems'
interface IJournalFeed {
  feed: journalItems_elements_edges_node[]
}

const JournalFeed: FC<IJournalFeed> = ({ feed }) => {
  return (
    <div className={css.feed}>
      {feed?.map((item) => {
        return <JournalItem key={item?.id} post={item} size="small" />
      })}
    </div>
  )
}

export default JournalFeed
